<script>
import * as echarts from 'echarts'
import { getMapData, getMapData2 } from '@/api/api'

export default {
  name: "topMap",
  data() {
    return {
      currentCity: null,
      currentData: [],
      activityData: [],
    }
  },
  computed: {
    cityData() {
      return this.currentData.filter(item => !item.sname?.includes('总活动'))
    },
    // activityData() {
    //   return this.currentData.filter(item => item.sname?.includes('总活动'))
    // }
  },
  mounted() {
    this.getData()
    this.initMap()
  },
  methods: {
    getData() {
      getMapData(this.currentCity).then(res => {
        this.currentData = res.data
      })
      getMapData2(this.currentCity).then(res => {
        if (res?.data?.length) {
          this.activityData = [{
            sname: res.data[0].hsname,
            mun: res.data[0].hmun
          }, {
            sname: res.data[0].sname,
            mun: res.data[0].mun
          }]
        }

      })
    },
    initMap() {
      const myChart = echarts.init(this.$refs.map)
      var option = null;
      const json = require('@/assets/mapJson/610000.json')
      echarts.registerMap('shanxi', json);
      option = {
        geo: [{
          map: 'shanxi',
          roam: false, //是否允许缩放
          zoom: 1.1, //默认显示级别
          scaleLimit: {
            min: 0,
            max: 3
          }, //缩放级别
          // itemStyle: {
          //   normal: {
          //     color:'#fff',
          //     areaColor: '#013C62',
          //     // shadowColor: '#013C62',
          //     // shadowBlur: 20,
          //     // shadowOffsetX: -5,
          //     // shadowOffsetY: 15,
          //   }
          // },
          label: {
            show: true,
            color: "#fff",
            emphasis: {
              color: "#fff",

            }
          },
          itemStyle: {
            normal: {
              borderColor: '#fff',
              borderWidth: 1,
              areaColor: '#5385d6',
            },
            select: {
              areaColor: '#50a3fe',
              color: '#fff',
              label: {
                show: true,
                color: '#fff'
              },
              borderWidth: 1,
            },
            emphasis: {
              areaColor: '#51a3fe',
              label: {
                show: true,
                color: '#fff'
              }
            }
          },

          tooltip: {
            show: false
          }
        }],
        series: [
          //地图
          {
            type: 'map',
            mapType: 'shanxi',
            geoIndex: 1,
            zoom: 1.1, //默认显示级别
            label: {
              show: true,
              color: '#ffffff',
              emphasis: {
                color: '#fff',
                show: true
              },
              select: {
                color: '#fff',

              }
            },
            itemStyle: {
              normal: {
                borderColor: '#fff',
                borderWidth: 1,
                areaColor: '#5385d6'
              },
              emphasis: {
                areaColor: '#51a3fe',
                borderWidth: 0,
                // color: '#fff'
              },
              select: {
                areaColor: '#50a3fe',
                color: '#fff',
                borderWidth: 1,
              }
            },
            data: []

            // data: Object.keys(center).map(name => {
            //   return {
            //     name: name,
            //     value: Math.random() * 100
            //   }
            // })
          }
        ]
      };
      myChart.setOption(option);
      myChart.on('selectchanged', (params) => {
        if (params.selected[0]) {
          // 选中区域
          const mapIndex = params.selected?.[0]?.dataIndex?.[0]
          console.log(json.features[mapIndex]?.properties?.name)
          this.currentCity = json.features[mapIndex]?.properties?.name
        } else {
          // 取消选中
          this.currentCity = null
        }
        this.getData()
      })

    }
  }
  ,
}
</script>

<template>
  <div class="top-map">
    <b-container class="d-flex justify-content-between top-map-center">
      <div class="top-map-left">
        <div class="top-box box">
          <div class="box-header">{{ currentCity || '陕西省' }}</div>
          <div class="box-content">
            <div class="box-item" v-for="(item, index) in cityData" :key="index">
              <img src="../assets/yanxue/right-icon.png" alt="" srcset="../assets/yanxue/right-icon.png" class="icon">
              <div class="item-label">
                {{ item.sname }}
              </div>
              <div class="item-value">{{ item.mun }}</div>
            </div>
          </div>
        </div>
        <div class="bottom-box box" v-if="activityData && activityData.length">
          <div class="box-header">活动统计</div>
          <div class="box-content">
            <div class="box-item activity" v-for="(item, index) in activityData" :key="index">
              <img src="../assets/yanxue/star.png" alt="" srcset="../assets/yanxue/star.png" class="icon"
                v-if="index % 2 === 0">
              <img src="../assets/yanxue/people.png" alt="" srcset="../assets/yanxue/people.png" class="icon" v-else>
              <div>
                <div class="item-label">
                  {{ item.sname }}
                </div>
                <div class="item-value">{{ item.mun }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="top-map-right">
        <div class="map" ref="map" @click.stop.prevent></div>
      </div>
    </b-container>
  </div>

</template>

<style scoped lang="scss">
.top-map {
  height: 987px;
  width: 100%;
  overflow: hidden;
  background: url("../assets/yanxue/map-box-bg.png") no-repeat center;
  background-size: 100% 100%;

  .top-map-center {
    height: 100%;
  }

  .top-map-left {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &-right {
    width: 500px;
    height: 100%;
    display: flex;
    align-items: center;

    .map {
      width: 100%;
      height: 800px;
    }
  }

  .box {
    width: 530px;
    line-height: 20px;
    border-radius: 6px;
    color: #101010;
    font-size: 14px;
    text-align: center;
    border: 1px solid #246ed2;
    //height: 300px;
    margin-bottom: 20px;

    .box-header {
      width: 530px;
      height: 52px;
      line-height: 52px;

      background: url("../assets/yanxue/box-header-bg.png");
      background-size: 100% 100%;
      position: relative;
      top: -2px;
      z-index: 2;
      font-size: 20px;

    }

    .box-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      padding: 20px;
    }

    .box-item {
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px;
      font-size: 20px;

      &.activity {
        height: unset;

        .icon {
          width: 105px;
          height: 105px;
        }

        .item-value {
          font-size: 28px;
          text-align: left;
        }
      }

      &:nth-child(2n+1) {
        position: relative;

        &:before {
          content: '';
          width: 1px;
          height: 100%;
          background: #0e77ea;
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      .icon {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }

      .item-label,
      .item-value {
        flex: 1;
      }

      .item-value {
        color: #265aaf;
        text-align: center;
      }
    }
  }
}
</style>